import { httpService } from '@/api/httpService'

const imageAndText = {
  state: {
    pdfData:[]
  },
  mutations: {
    SET_PDF_DATA:(state, data) => {
      state.pdfData = data
    }
  },
  actions: {
    getImageAndText ({ commit }, params) {
      const { patientid, studyid, hospcode, hospdomain, tcStType, checkTime } = params
      return new Promise((resolve, reject) => {
        httpService({
          url: 'getImageAndText',
          method: 'get',
          params: {
            patientid,
            studyid,
            hospcode,
            hospdomain,
            tcStType,
            checkTime
          }
        }).then(response => {
          // response.result.list.push(response.result.list[0])
          // response.result.list.push(response.result.list[0])
          // response.result.list.push(response.result.list[0])
          commit('SET_PDF_DATA', response.result.list)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default imageAndText
